// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/balance-health/document-mappings.yaml
// Run: bun run scripts/mappings/balance-health-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const BALANCE_HEALTH_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Sign",
      "Task Details: Letter of Medical Necessity"
    ],
    assignedTo: "Physician",
    displayName: "Letter of Medical Necessity",
    documentLabel: "Letter of Medical Necessity",
    folder: "Results - PT/OT",
    folderMapping: "Results - PT/OT",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "balance-health"
  },
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Disability Paperwork"
    ],
    assignedTo: null,
    displayName: "Disability Paperwork",
    documentLabel: "Disability Paperwork",
    folder: "Disability",
    folderMapping: "Disability",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "balance-health"
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: FMLA Paperwork"
    ],
    assignedTo: null,
    displayName: "FMLA Paperwork",
    documentLabel: "FMLA Paperwork",
    folder: "Disability",
    folderMapping: "Disability",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "balance-health"
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Questionnaire for Orthosis",
    documentLabel: "Questionnaire for Orthosis",
    folder: "Custom Device Documents",
    folderMapping: "Custom Device Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE,
    group: "balance-health"
  },
  [Classification.ADMIN_TRANSITION_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Transition of Care, Referral Notes",
    documentLabel: "Transition of Care, Referral Notes",
    folder: "Results - Clinical Notes",
    folderMapping: "Results - Clinical Notes",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_TRANSITION_CARE,
    group: "balance-health"
  },
  [Classification.ADMIN_WORK_OR_SCHOOL_PHYSICAL_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Work Status Req."
    ],
    assignedTo: "Physician",
    displayName: "Work/School Physical Forms",
    documentLabel: "Work Status Req.",
    folder: "Disability",
    folderMapping: "Disability",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_WORK_OR_SCHOOL_PHYSICAL_FORMS,
    group: "balance-health"
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Clearance Request"
    ],
    assignedTo: "Physician",
    displayName: "Clearance Request",
    documentLabel: "Clearance Request",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "balance-health"
  },
  [Classification.CLEARANCE_REQUEST_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Clearance Response"
    ],
    assignedTo: "Physician",
    displayName: "Clearance Response",
    documentLabel: "Clearance Response",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST_RESPONSE,
    group: "balance-health"
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Sign",
      "Task Details: DM Shoe Certification"
    ],
    assignedTo: "Physician",
    displayName: "DM Shoe Certification",
    documentLabel: "DM Shoe Certification",
    folder: "Results - PT/OT",
    folderMapping: "Results - PT/OT",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "balance-health"
  },
  [Classification.FINANCIAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Fax",
      "Note: do not upload to chart"
    ],
    assignedTo: "Billing Inquiries",
    displayName: "Financial",
    documentLabel: "Financial",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.FINANCIAL,
    group: "balance-health"
  },
  [Classification.FINANCIAL_ELIGIBILITY_OF_BENEFITS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Verification of Benefits",
    documentLabel: "Verification of Benefits and Eligibility & Benefits",
    folder: "Authorization",
    folderMapping: "Authorization",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL_ELIGIBILITY_OF_BENEFITS,
    group: "balance-health"
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Copy of Patient ID",
    documentLabel: "Copy of Patient ID",
    folder: "Patient ID Card",
    folderMapping: "Patient ID Card",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "balance-health"
  },
  [Classification.IMAGING_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Imaging Results"
    ],
    assignedTo: "Physician",
    displayName: "Imaging Results",
    documentLabel: "Imaging Results",
    folder: "Radiology Report",
    folderMapping: "Radiology Report",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS,
    group: "balance-health"
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Imaging Results CT"
    ],
    assignedTo: "Physician",
    displayName: "CT Imaging Results",
    documentLabel: "Imaging Results CT",
    folder: "Radiology Report",
    folderMapping: "Radiology Report",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "balance-health"
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Imaging Results MRI"
    ],
    assignedTo: "Physician",
    displayName: "MRI Imaging Results",
    documentLabel: "Imaging Results MRI",
    folder: "Radiology Report",
    folderMapping: "Radiology Report",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "balance-health"
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Imaging Results Ultrasound"
    ],
    assignedTo: "Physician",
    displayName: "Ultrasound Imaging Results",
    documentLabel: "Imaging Results Ultrasound",
    folder: "Radiology Report",
    folderMapping: "Radiology Report",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "balance-health"
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Copy of Patient Insurance Card",
    documentLabel: "Copy of Patient Insurance Card",
    folder: "Patient ID Card",
    folderMapping: "Patient ID Card",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "balance-health"
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Schedule"
    ],
    assignedTo: "Physician",
    displayName: "Intake",
    documentLabel: "Intake",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "balance-health"
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Junk",
    documentLabel: "Junk",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "balance-health"
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Lab Report"
    ],
    assignedTo: "Physician",
    displayName: "Lab Report",
    documentLabel: "Lab Report",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "balance-health"
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Pathology Report"
    ],
    assignedTo: null,
    displayName: "Pathology Report",
    documentLabel: "Pathology Report",
    folder: "Path Report",
    folderMapping: "Path Report",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "balance-health"
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Home Health Care",
    documentLabel: "Home Health Care, Plan of Care",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "balance-health"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Fax",
      "Task Details: Medical Records Req."
    ],
    assignedTo: "Medical Records",
    displayName: "Medical Records Req.",
    documentLabel: "Medical Records Req.",
    folder: "Legal",
    folderMapping: "Legal",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "balance-health"
  },
  [Classification.NOTIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Notification",
    documentLabel: "Notification",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION,
    group: "balance-health"
  },
  [Classification.NOTIFICATION_HOSPITAL_ADMIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Admission records"
    ],
    assignedTo: null,
    displayName: "Admission records",
    documentLabel: "Admission records",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_ADMIT,
    group: "balance-health"
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Lab Info Req."
    ],
    assignedTo: null,
    displayName: "Lab Info Req.",
    documentLabel: "Lab Info Req.",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_LAB,
    group: "balance-health"
  },
  [Classification.ORDER_PROCEDURE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Sx Schd. Order Form"
    ],
    assignedTo: "UT COB Surgery",
    displayName: "Sx Schd. Order Form",
    documentLabel: "Sx Schd. Order Form",
    folder: "Surgical Documents",
    folderMapping: "Surgical Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_PROCEDURE,
    group: "balance-health"
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review"
    ],
    assignedTo: "Physician",
    displayName: "Other",
    documentLabel: "Other",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.OTHER,
    group: "balance-health"
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Pharmacy Communication"
    ],
    assignedTo: "Physician",
    displayName: "Pharmacy Communication",
    documentLabel: "Pharmacy Communication",
    folder: "Prescription Documents",
    folderMapping: "Prescription Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED,
    group: "balance-health"
  },
  [Classification.PHARMACY_RELATED_CARE_CONSIDERATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Potential Clinical Concerns"
    ],
    assignedTo: "Physician",
    displayName: "Potential Clinical Concerns",
    documentLabel: "Potential Clinical Concerns",
    folder: "Prescription Documents",
    folderMapping: "Prescription Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CARE_CONSIDERATION,
    group: "balance-health"
  },
  [Classification.PHARMACY_RELATED_NON_ADHERENCE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Medication Non-Adherence Notice",
    documentLabel: "Medication Non-Adherence Notice",
    folder: "Prescription Documents",
    folderMapping: "Prescription Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_NON_ADHERENCE,
    group: "balance-health"
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Obtain",
      "Task Details: Rx Refill Req."
    ],
    assignedTo: "Physician",
    displayName: "Rx Refill Request",
    documentLabel: "Rx Refill Req.",
    folder: "Prescription Documents",
    folderMapping: "Prescription Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "balance-health"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Obtain",
      "Task Details: Prior Auth. Req."
    ],
    assignedTo: null,
    displayName: "Prior Auth. Req.",
    documentLabel: "Prior Auth. Req.",
    folder: "Prescription Documents",
    folderMapping: "Prescription Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "balance-health"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Notice of Medication Auth Status",
    documentLabel: "Notice of {{ authorizationStatus }}",
    folder: "Prescription Documents",
    folderMapping: "Prescription Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "balance-health"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Auth. Req."
    ],
    assignedTo: "UT COB Surgery",
    displayName: "Auth. Req.",
    documentLabel: "Auth. Req.",
    folder: "Authorization",
    folderMapping: "Authorization",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "balance-health"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Notice of {{ authorizationStatus }}"
    ],
    assignedTo: null,
    displayName: "Notice of Procedure Auth Status",
    documentLabel: "Notice of {{ authorizationStatus }}",
    folder: "Authorization",
    folderMapping: "Authorization",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "balance-health"
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Consult Notes",
    documentLabel: "Consult Notes, {{ provider }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "balance-health"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Summary of Care/Discharge Notes",
    documentLabel: "Summary of Care/Discharge Notes",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "balance-health"
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "OP Report",
    documentLabel: "OP Report, DOS {{ dateOfEvent DD/MM/YY }}",
    folder: "Surgical Documents",
    folderMapping: "Surgical Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "balance-health"
  },
  [Classification.PROGRESS_NOTE_PRE_OPERATIVE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Pre-Op Notes & Evaluation"
    ],
    assignedTo: "Physician",
    displayName: "Pre-Op Notes & Evaluation",
    documentLabel: "Pre-Op Notes & Evaluation",
    folder: "Surgical Documents",
    folderMapping: "Surgical Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_PRE_OPERATIVE,
    group: "balance-health"
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Schedule",
      "Task Details: Referral",
      "Task Notes: {{ reasonForReferral }}",
      "Task Facility: UT Salt Lake City 400 W",
      "Task Priority: {{ taskPriority }}"
    ],
    assignedTo: "Physician",
    displayName: "Referral",
    documentLabel: "{{ dateOfReferral }} Referral",
    folder: "Referral/Authorization Notes",
    folderMapping: "Referral/Authorization Notes",
    inputDate: "Date Of Referral",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    classification: Classification.REFERRAL,
    group: "balance-health"
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Referral Response"
    ],
    assignedTo: "Physician",
    displayName: "Referral Response",
    documentLabel: "Referral Response",
    folder: "Referral/Authorization Notes",
    folderMapping: "Referral/Authorization Notes",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "balance-health"
  },
  [Classification.REFERRAL_STATUS_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Referrals Status Request"
    ],
    assignedTo: "Physician",
    displayName: "Referrals Status Request",
    documentLabel: "Referrals Status Request",
    folder: "Referral/Authorization Notes",
    folderMapping: "Referral/Authorization Notes",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_STATUS_REQUEST,
    group: "balance-health"
  }
} as const;
